export function reminderValidationMessage(dueDate: string, reminderAt: string): string {
  if (!reminderAt) return "";
  if (Number.isNaN(new Date(reminderAt).getTime())) return "Enter a valid reminder date and time.";
  if (dueDate && reminderAt.slice(0, 10) > dueDate) return "Set the reminder on or before the due date.";
  return "";
}
